/**
 * @generated SignedSource<<45e1ebe07898270477e63144dfbb1bb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
import { FragmentRefs } from "relay-runtime";
export type ProfileScreenEmployeeTodaysShifts_employeeShift$data = {
  readonly formattedEndAtTime: string;
  readonly formattedStartAtTime: string;
  readonly id: string;
  readonly scheduleType: {
    readonly assignedTeams: ReadonlyArray<{
      readonly color: string | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
    }>;
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly secondaryScheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly status: EmployeeShiftStatus;
  readonly " $fragmentType": "ProfileScreenEmployeeTodaysShifts_employeeShift";
};
export type ProfileScreenEmployeeTodaysShifts_employeeShift$key = {
  readonly " $data"?: ProfileScreenEmployeeTodaysShifts_employeeShift$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeTodaysShifts_employeeShift">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileScreenEmployeeTodaysShifts_employeeShift",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedStartAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedEndAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleSecondaryType",
      "kind": "LinkedField",
      "name": "secondaryScheduleType",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "scheduleType",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeams",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AHTeamIcon"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeShift",
  "abstractKey": null
};
})();

(node as any).hash = "19429cb31bd32e8ebda9252f2dc79cf1";

export default node;
